/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useCallback, useState} from 'react'
import {useDropzone} from 'react-dropzone'
import {Field, ErrorMessage, useField} from 'formik'
import {AnimaBaixo, AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import {useIntl} from 'react-intl'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {deleteFileLicenses} from '../../../../components/licenses-list/core/_requests'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const Step4: FC = () => {
  const [fieldControlConditionings, , helperControlConditionings] =
    useField('control_conditionings')
  const [field3, , helpers3] = useField('file')
  const [fieldUuid, ,] = useField('uuid')
  const [active, setActive] = useState<boolean>(false)
  const intl = useIntl()

  //Condicial para verificar se o arquivo existe e renomear para exibir no front
  let file = ''
  if (field3.value !== null && field3.value !== undefined && field3.value !== 0) {
    file = field3.value.toString()
    //remove o link do arquivo
    file = file.replace(
      'https://controlcloud.blob.core.windows.net/siriusbackend/Local_ENV/sga/licenses/',
      ''
    )
    //remove uuid do arquivo
    let file1 = file.split('-', 1)
    file = file.replace(file1 + '-', '').replace('.pdf', '')
  }

  function deleteMsgFileLicense() {
    const MySwal = withReactContent(Swal)

    MySwal.fire({
      title: intl.formatMessage({id: 'LICENSES.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (fieldUuid.value !== undefined) {
          helpers3.setValue(null)
          setActive(true)
          deleteFileLicenses(fieldUuid.value)
        }
      }
    })
  }

  function deleteMsgFileAll() {
    const MySwal = withReactContent(Swal)

    MySwal.fire({
      title: intl.formatMessage({id: 'LICENSES.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        helpers3.setValue(null)
        setActive(false)
      }
    })
  }

  const onDrop = useCallback((acceptedFiles: any) => {
    helpers3.setValue(acceptedFiles[0])
    setActive(true)
    // eslint-disable-next-line
  }, [])
  const {getRootProps, getInputProps, isDragActive, acceptedFiles} = useDropzone({onDrop})

  const files = acceptedFiles.map((file: any) => (
    <AnimaBaixo>
      {/* <p className='text-primary mt-10 dropzone'>
        <img alt='' className='w-30px me-3' src={toAbsoluteUrl('/media/svg/files/pdf.svg')} />{' '}
        {file.name} <span className='text-gray-600'>- {file.size} bytes</span>
      </p> */}
      <>
        <div className='row mt-10 dropzone'>
          <div className='col-lg-11'>
            <p className=' d-flex align-items-left position-relative'>
              <img alt='' className='w-30px mx-3' src={toAbsoluteUrl('/media/svg/files/pdf.svg')} />{' '}
              <span className='text-primary fw-bold mt-2'> {file.name} </span>
              <span className='text-gray-600 mt-2'>- {file.size} bytes</span>
            </p>
          </div>
          <div className='col-lg-1'>
            <button
              type='button'
              title='Excluir arquivo'
              onClick={() => deleteMsgFileAll()}
              className='btn btn-sm btn-icon btn-icon-danger p-3 ms-3'
            >
              <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-1' />{' '}
            </button>
          </div>
        </div>
      </>
    </AnimaBaixo>
  ))

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder d-flex align-items-center text-dark'>
            {intl.formatMessage({id: 'LICENSES.TITLE_STEAP4'})}
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Billing is issued based on your selected account type'
            ></i>
          </h2>

          <div className='text-gray-400 fw-bold '>
            {intl.formatMessage({id: 'LICENSES.SUBTITLE2_STEAP4'})}
          </div>
        </div>

        <div className='row mb-5'>
          <div className='col-lg-12 '>
            <label className='form-label fw-bold d-flex mb-3 required'>
              {intl.formatMessage({id: 'LICENSES.CONTROL_CONDITIONERS'})}
            </label>
            <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
              <label className='form-check-label'>
                {intl.formatMessage({id: 'COMMON.NO'})}
                &nbsp;
              </label>

              <input
                className='form-check-input h-20px w-30px'
                type='checkbox'
                id='control_conditionings'
                defaultChecked={fieldControlConditionings.value}
                onChange={() => {
                  helperControlConditionings.setValue(!fieldControlConditionings.value)
                }}
              />
              <label className='form-check-label'>{intl.formatMessage({id: 'COMMON.YES'})}</label>
            </div>
          </div>
        </div>

        <div className='fv-row'>
          <div className='row'>
            <div className='col-lg-12'>
              <Field
                type='radio'
                className='btn-check'
                name='accountType'
                value='personal'
                id='kt_create_account_form_account_type_personal'
              />
            </div>

            <div className='text-danger mt-2'>
              <ErrorMessage name='accountType' />
            </div>
          </div>

          {/* <Field component={MyDropzone} type='file' accept='.pdf' {...field3} />
          <ErrorMessage name='tes'>{(msg) => <div style={{color: 'red'}}>{msg}</div>}</ErrorMessage> */}
          {/* inicio teste dropzone */}
          <div className='dropzone'>
            <div {...getRootProps()}>
              <div className='dz-message needsclick'>
                <i className='bi bi-file-earmark-arrow-up text-primary fs-3x'></i>
                <div className='ms-4'>
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <h3 className='fs-7 fw-bold text-gray-900 mb-1'>
                      {intl.formatMessage({id: 'DROPZONE.TITLE_DRAG'})}
                    </h3>
                  ) : (
                    <h3 className='fs-7 fw-bold text-gray-900 mb-1'>
                      {intl.formatMessage({id: 'DROPZONE.TITLE'})}
                    </h3>
                  )}
                  <label htmlFor='license_documentation' className='fs-8 fw-semibold text-gray-400'>
                    {intl.formatMessage({id: 'DROPZONE.SUBTITLE'})}
                  </label>
                </div>
              </div>
            </div>
            {active ? (
              <p> {files}</p>
            ) : (
              <AnimaBaixo>
                {field3.value !== null && (
                  <>
                    <div className='row mt-10 dropzone'>
                      <div className='col-lg-11'>
                        <a href={field3.value} target='_blank' rel='noreferrer'>
                          <p className=' d-flex align-items-left position-relative'>
                            <img
                              alt=''
                              className='w-30px mx-3'
                              src={toAbsoluteUrl('/media/svg/files/pdf.svg')}
                            />{' '}
                            <span className='text-primary fw-bold mt-2'> {file} </span>
                            {/* <span className='text-gray-600 mt-2'>- {file.size} bytes</span> */}
                          </p>
                        </a>
                      </div>
                      <div className='col-lg-1'>
                        <button
                          type='button'
                          title='Excluir arquivo'
                          onClick={() => deleteMsgFileLicense()}
                          className='btn btn-sm btn-icon btn-icon-danger p-3 ms-3'
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen027.svg'
                            className='svg-icon-1'
                          />
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </AnimaBaixo>
            )}
          </div>
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step4}
